module.exports = "<div class=\"sk-three-bounce\">\n  <div class=\"sk-child sk-bounce1\"></div>\n  <div class=\"sk-child sk-bounce2\"></div>\n  <div class=\"sk-child sk-bounce3\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/components/app-spinner/app-spinner.component.html
// module id = ../../../../../src/app/components/app-spinner/app-spinner.component.html
// module chunks = main